export function compareByCurrentUser(currentUserId) {
  return (a, b) => {
    if (a.value === currentUserId) return -1;
    if (b.value === currentUserId) return 1;
    return 0;
  };
}
